import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './FamilyOverview.css';
import addPersonIcon from '../../assets/addPersonIcon.jpg';
import deleteIcon from '../../assets/deleteIcon.jpg';
import editIcon from '../../assets/editIcon.jpg';
import PageHeader from './PageHeader';

const FamilyOverview = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    document.title = 'LeapFrog Lab Registration Admin Portal';
  }, []);

  // Extract state
  const {
    familyData = {},
    guardianData = [],
    childData = [],
  } = location.state || { familyData: {}, guardianData: [], childData: [] };

  // Format the createdDate if it's a Date object
  const formattedCreatedDate = familyData.createdDate
    ? new Date(familyData.createdDate).toLocaleDateString()
    : '';

  return (
    <div className="family-overview">
      <PageHeader title={`The ${familyData.familyName} Family`} />

      <p className="section-title">
        <strong>Family Details</strong>
      </p>
      {familyData && (
        <section className="family-details">
          <p>
            <div className="detail-item">
              <strong className="green-label">Family name: </strong>
              {familyData.familyName}
            </div>
            <div className="detail-item">
              <strong className="green-label">Unique Id:</strong>{' '}
              {familyData.guid}
            </div>
            <div className="detail-item">
              <strong className="green-label">Referred by:</strong>{' '}
              {familyData.referredBy}
            </div>
            <div className="detail-item">
              <strong className="green-label">Ok to contact?</strong>{' '}
              {familyData.okayToContactIndicator ? 'Y' : 'N'}
            </div>
            <div className="detail-item">
              <strong className="green-label">Member since:</strong>{' '}
              {formattedCreatedDate}
            </div>
          </p>
          <div className="action-links">
            <a href="#">
              <img
                src={editIcon}
                alt="icon"
                style={{ width: '18px', height: '18px' }}
              />{' '}
              Edit
            </a>
            <a href="#">
              <img
                src={deleteIcon}
                alt="icon"
                style={{ width: '21px', height: '20px' }}
              />{' '}
              Delete
            </a>
          </div>
        </section>
      )}
      <p className="section-title">
        <strong>Guardian Details</strong>
      </p>
      {guardianData && (
        <section className="guardian-details">
          <p>
            <div className="detail-item">
              <strong className="green-label">First name:</strong>{' '}
              {guardianData.firstName}
            </div>
            <div className="detail-item">
              <strong className="green-label">Last name:</strong>{' '}
              {guardianData.lastName}
            </div>
            <div className="detail-item">
              <strong className="green-label">Relationship:</strong>{' '}
              {guardianData.relationshipToChild}
            </div>
            <div className="detail-item">
              <strong className="green-label">Email:</strong> {guardianData.eml}
            </div>
            <div className="detail-item">
              <strong className="green-label">Phone:</strong>{' '}
              {guardianData.primaryPhone}
            </div>
            <div className="detail-item">
              <strong className="green-label">Zip:</strong>{' '}
              {guardianData.zipcode}
            </div>
            <div className="detail-item">
              <strong className="green-label">City:</strong>{' '}
              {guardianData.zipcode}
            </div>
          </p>
          <div className="action-links">
            <a href="#">
              <img
                src={editIcon}
                alt="icon"
                style={{ width: '18px', height: '18px' }}
              />{' '}
              Edit
            </a>
            <a href="#">
              <img
                src={deleteIcon}
                alt="icon"
                style={{ width: '21px', height: '20px' }}
              />{' '}
              Delete
            </a>
          </div>
        </section>
      )}
      <p className="section-title">
        <strong>Child Details</strong>
      </p>
      {childData && (
        <section className="child-details">
          <p>
            <div className="detail-item">
              <strong className="green-label">First name:</strong>{' '}
              {childData.firstName}
            </div>
            <div className="detail-item">
              <strong className="green-label">Gender:</strong>{' '}
              {childData.gender}
            </div>
            <div className="detail-item">
              <strong className="green-label">DOB:</strong> {childData.mob},{' '}
              {childData.yearOfBirth}
            </div>
            <div className="detail-item">
              <strong className="green-label">Which hand:</strong>{' '}
              {childData.whichHandId}
            </div>
            <div className="detail-item">
              <strong className="green-label">Language spoken at home:</strong>{' '}
              {childData.languageSpokenAtHome}
            </div>
            <div className="detail-item">
              <strong className="green-label">Additional Language 1:</strong>{' '}
              {childData.additionalLanguage1}
            </div>
            <div className="detail-item">
              <strong className="green-label">Additional Language 2:</strong>{' '}
              {childData.additionalLanguage2}
            </div>
          </p>
          <div className="action-links">
            <a href="#">
              <img
                src={editIcon}
                alt="icon"
                style={{ width: '18px', height: '18px' }}
              />{' '}
              Edit
            </a>
            <a href="#">
              <img
                src={deleteIcon}
                alt="icon"
                style={{ width: '21px', height: '20px' }}
              />{' '}
              Delete
            </a>
          </div>
        </section>
      )}
    </div>
  );
};

export default FamilyOverview;
